export default ({
  control: {
    backgroundColor: '#fff',
		fontSize: "14px",
		fontWeight: 'normal',
  },

  input: {
    margin: 0,
  },

  '&multiLine': {
    highlighter: {
      padding: 9,
    },

    input: {
		border: "1px solid rgb(221, 221, 221)"
      , borderRadius: "2px"
      , margin: "0px 0px 10px"
      , boxShadow: "rgb(171, 171, 171) 0px 1px 8px -3px inset"
      , padding: 9
	  , fontSize: "14px"
	  , outline: 0
    },
  },

  suggestions: {
    list: {
      backgroundColor: 'white',
      border: 'none',
      fontSize: 14,
	  minWidth: "200px"
    },

    item: {
      padding: '10px 15px',

      '&focused': {
        backgroundColor: '#cee4e5',
      },
    },
  },
})



// WEBPACK FOOTER //
// ./src/components/Communication/inputStyles.js